// Note:
// _menu: nếu là các menu
// _act: nếu là các action của button, ...

export const GlobalPolcies = {
  managePermission: {
    leftmenu: '5001', //web: menu left - Quản trị hệ thống - Phân quyền
    tai_khoan: '5001', //web: menu left - Tài khoảnks
  },
  mThongTinSinhVienV2: {
    left_menu: {
      dashboard: {
        home: '',
        metabase: '2' // menu: Dashboard Metabase
      },
      ho_so_sinh_vien: '', //web: menu left - Hồ sơ sinh viên
      thong_tin_sinh_vien: '', //web: menu left - Thông tin cá nhân
      import_excel: {
        quan_ly_import: '', //web: menu left - Import Excel - Quản lý import
        import_ban_can_su: '', //web: menu left - Import Excel - Import bạn cần sự
        import_ky_nang_mem: '', //web: menu left - Import Excel - Import kỹ năng mềm
        import_hoi_sinh_vien: '', //web: menu left - Import Excel - Import hội sinh viên
        import_nghien_cuu_khoa_hoc: '', //web: menu left - Import Excel - Import nghiên cứu khoa học
        import_hoat_dong_sinh_vien: '', //web: menu left - Import Excel - Import hoạt động sinh viên
        import_cong_tac_doan_thanh_nien: '', //web: menu left - Import Excel - Import công tác đoàn thanh niên
        import_cong_tac_dang: '', //web: menu left - Import Excel - Import công tác đảng
        import_cau_lac_bo: '', //web: menu left - Import Excel - Import câu lạc bộ
        import_dang_doan_hoi: '', //web: menu left - Import Excel - Import Đảng - Đoàn - Hội
        manage_import_ban_can_su: '', //web: menu left - Import Excel - Import bạn cần sự
        manage_import_ky_nang_mem: '', //web: menu left - Import Excel - Import kỹ năng mềm
        manage_import_hoi_sinh_vien: '', //web: menu left - Import Excel - Import hội sinh viên
        manage_import_nghien_cuu_khoa_hoc: '', //web: menu left - Import Excel - Import nghiên cứu khoa học
        manage_import_hoat_dong_sinh_vien: '', //web: menu left - Import Excel - Import hoạt động sinh viên
        manage_import_cong_tac_doan_thanh_nien: '', //web: menu left - Import Excel - Import công tác đoàn thanh niên
        manage_import_cong_tac_dang: '', //web: menu left - Import Excel - Import công tác đảng
        manage_import_cau_lac_bo: '', //web: menu left - Import Excel - Import câu lạc bộ
        manage_import_dang_doan_hoi: '' //web: menu left - Import Excel - Import Đảng - Đoàn - Hội
      }, //web: menu left - Import Excel
      dong_bo_du_lieu: '', //web: menu left - Đồng bộ dữ liệu
      tra_cuu_thong_tin: '', //web: menu left - Tra cứu thông tin
    },
    dashboard: {
      count_sync_data: '' //action: dashboard
    },
    action: {
      print: {
        thong_tin_sinh_vien_pdf: '1' //action: In thông tin sinh viên PDF
      }
    }
  }
};
